// components/SEO/SEOHelmet.jsx
import React from "react";
import { Helmet } from "react-helmet-async";

export const SEOHelmet = ({
  title = "Deedmed - Online Healthcare Services Sri Lanka",
  description = "Book online doctor consultations, video calls with certified physicians, and order medicines. Advanced telemedicine services across Sri Lanka.",
  keywords = "telemedicine Sri Lanka, online doctor consultation, healthcare services, video consultation, medicine delivery",
  image = "https://deedmed.lk/images/og-image.jpg",
  url = "https://deedmed.lk",
  type = "website",
  structuredData = null,
}) => {
  const schemaMarkup = structuredData || {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "Deedmed",
    url: "https://deedmed.lk",
    logo: "https://deedmed.lk/images/logo.png",
    description: description,
    address: {
      "@type": "PostalAddress",
      streetAddress:
        "2nd Floor, Paramount Tower, 192/10, 9th Lane, Nawala Road",
      addressLocality: "Nawala",
      addressCountry: "LK",
    },
    contactPoint: {
      "@type": "ContactPoint",
      contactType: "Customer Service",
      areaServed: "LK",
    },
  };

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="robots" content="index, follow" />
      <meta name="googlebot" content="index, follow" />

      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Deedmed" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* Canonical */}
      <link rel="canonical" href={url} />

      {/* Structured Data */}
      <script type="application/ld+json">{JSON.stringify(schemaMarkup)}</script>
    </Helmet>
  );
};
